/**
 * Los `kind` de tool card: las herramientas del agente que se contestan con una TARJETA
 * dibujada en el chat.
 *
 * Vive en un módulo hoja (sin React ni supabase) por dos motivos: se puede testear solo, y
 * `useV2Chat` necesita la lista en TIEMPO DE EJECUCIÓN — no alcanza con el tipo. Una tool
 * que llega al despacho de cards sin estar acá no tiene quién la dibuje: la tarjeta sale
 * invisible y su promesa no se resuelve nunca, así que el turno se queda "pensando" hasta
 * que el usuario aprieta Detener (ADR-2026-09-13-una-tool-sin-card-no-cuelga-el-turno).
 */
export const V2_TOOL_CARD_KINDS = [
  'pick_product',
  'pick_model',
  'pick_pose',
  'pick_format',
  'pick_background',
  'confirm_generate',
  'confirm_research',
  'generate_image',
  'generate_audio',
  'generate_video',
  'show_recent_media',
  'mostrar_guardado',
  'crear_planilla',
  'crear_pdf',
  'editar_lanzamiento',
  'agregar_a_lanzamiento',
  'contact_support',
  // Llevar a conectar la Tiendanube: la tarjeta tiene el botón, porque el agente NO
  // puede cambiarle la pantalla de una a alguien que está leyendo
  // (ADR-2026-09-18-tiendanube-en-el-chat).
  'conectar_tienda',
  // Lo mismo para Instagram (ADR-2026-09-24-instagram-boton-en-mi-marca).
  'conectar_instagram',
  // Y para los anuncios de Meta (ADR-2026-09-24-anuncios-de-meta-en-el-chat).
  'conectar_anuncios',
  // Y para Mercado Libre (ADR-2026-09-28-mercadolibre-en-el-chat).
  'conectar_mercadolibre',
  // Trabajo en lote (ADR-2026-09-08-el-chat-trabaja-en-lote).
  'generar_lote_imagenes',
  'agregar_productos',
  // Preguntar con opciones (ADR-2026-09-11-preguntar-con-opciones-en-el-chat) y elegir
  // una creación ya hecha — sólo en este modo.
  'preguntar',
  'pick_creacion',
] as const;

export type V2ToolCardKind = (typeof V2_TOOL_CARD_KINDS)[number];

const KINDS = new Set<string>(V2_TOOL_CARD_KINDS);

export const esKindDeCard = (nombre: string): nombre is V2ToolCardKind => KINDS.has(nombre);
